import Vue from "vue";

import Vuex from "vuex";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

import packageModule from "./modules/package";
import bookingModule from "./modules/booking";
import accountingHomeLiabilityModule from "./modules/accountinghomeliability";

Vue.use(Vuex);

const DEFAULT_PAGE_SIZE = 50;
const DEFAULT_PAGE_POSITION = 1;

export default new Vuex.Store({
  state: {
    token: "",
    user: {
      authenticated: false
    },
    login: {
      id: "",
      username: "",
      firstname: "",
      lastname: "",
      email: "",
      lastlogin: "",
      group_id: "",
      group_name: "",
      role: "",
      privilege_id: "",
      privilege_name: "",
      url_avatar: "",
      permissions: []
    },
    activatedProject: null,
    file_upload_case_data: [],
    projects: {},
    projectmodules: [],
    templateemailobject: [],
    available_module: [],
    get_template_email_data: [],
    templateEmailDetailData: [],
    snackbar: [],
    floor_apartment: [],
    customer_give_reward_point: [],
    projectemailtemplate: [],
    get_smtp_config: {},
    get_smtp_project: {},
    get_config_smtp_email_server: {},
    smtpProjectConfigList: {},
    settingProjectSMTP: [],
    smtpProjectList: [],
    customers: [],
    userguest: [],
    userguestdetail: [],
    invoiceCustomer: [],
    users: [],
    batch_jobs_history: [],
    customerDetails: {},
    userDetails: {},
    customerReturnData: null,
    cards: [],
    get_project_template_used: {},
    relatives: [],
    relativeDetails: {},
    lang: "vi",
    pagination: {
      page: DEFAULT_PAGE_POSITION,
      total: 0,
      size: DEFAULT_PAGE_SIZE
    },
    paginator: [],
    pageArrow: {
      prev: null,
      next: null
    },
    services: [],
    serviceDetails: {},
    serviceReturnData: null,
    serviceTypes: [],
    serviceHistory: [],
    projectallmodules_new_project: [],
    serviceAssigned: [],
    contract_data: [],
    contract_detail: {},
    file_upload_contract_data: [],
    file_upload_user_data: [],
    payment_progress: [],
    payment_progress_detail: {},
    serviceRecordHistory: [],
    propertys: [],
    propertyDetails: {},
    propertyTypes: [],
    get_bulk_data_import: [],
    cleaningService: [],
    cleaningServiceStartEnd: [],

    invoices: [],
    einvoices: [],
    invoices_list_performance: [],
    invoices_list_performance_vs2: [],
    invoices_receipt_list_performance: [],
    filterInvoices: [],
    invoiceDetails: {},
    invoiceReturnData: null,
    todoList: [],
    invoiceStatus: [],
    invoiceStatusDetails: {},
    invoiceStatusReturnData: null,
    mobile_notification: [],
    apartments: [],
    apartmentListNoPage: [],
    available_apartments: [],
    apartmentcodefromaccounthomebalance: [],
    reportmonthlyusage: [],
    reportusage: [],
    apartmentservicemonthlyusage: [],
    deleteApartmentScheduleProgressResult: [],
    apartmentScheduleProgressDetails: {
      contract_number: "",
      contract_name: "",
      id: 0
    },
    apartmentRealestateDetails: {
      realestate_code: "",
      id: 0,
      size: null
    },
    apartmentDetails: {
      apartment_code: "",
      apartmenthistory: [],
      apartmentservices: [],
      id: 0,
      size: null,
      status: null,
      rent: false
    },
    vehicles: [],
    vehicleDetails: {},
    vehicle_types: [],
    vehicle_manufacturers: [],
    cases: [],
    staffs: [],
    caseDetails: {
      id: 0,
      case_type_details: {
        name: ""
      },
      case_subtype_details: {
        name: ""
      },
      case_reporter: {
        first_name: "",
        last_name: ""
      },
      date_created: null,
      date_updated: null,
      open_date: null,
      resolved_date: null,
      close_date: null,
      status: null,
      title: "",
      description: null,
      screenshot: null,
      priority: null,
      due_date: null,
      escalation_process: null,
      escalation_stage: null,
      case_type: null,
      case_sub_type: null,
      assign_to: null,
      assignee: null,
      user_created: null,
      casehistory: []
    },
    escalationProcesses: [],
    escalationStages: [],
    residents: [],
    apartmentMonthlyUsage: [],
    residentDetails: null,
    assets: [],
    assetDetails: [],
    assetTypes: [],
    advertise: [],
    advertiseProjectInfo: [],
    available_module_project_info: [],
    advertiseprojectinfodetail: {},
    advertisedetail: {},
    invoiceListByTemplate: [],
    customizetablepersonalconfig: [],
    memberrolecodes: [],
    projectallmodules: [],
    rolepermission: [],
    current_role: "",
    functions: [],
    functionpermissions: [],
    apartment_permissions: [],
    apartment_monthly_usage_liabilities: [],
    project_history_list: [],
    project_bank_transfer: [],
    search_list: {},
    project_all_all_module: [],
    receipts: [],
    receiptDetails: {},
    batchJobDetails: {},
    // Apartment Search Storage
    apartmentSearchListStorage: {},
    leaseBackApartmentSearchListStorage: {},
    available_banks: [],

    // Mobile Application, OS and OS Version
    mobileApplications: [],
    mobileApplicationDetails: {},
    mobileOperationSystems: [],
    mobileOperationSystemDetails: {},
    mobileOSVersion: [],
    mobileOSVersionDetails: {},
    repairList: [],
    statisticalExportInvoice: [],
    statisticalApartmentPaymentLate: [],
    coupons: [],
    couponDetails: {},
    couponCode: {},
    apartmentReservations: [],
    sendInvoiceInformationToUser: [],
    deleteInvoiceListResult: [],
    emailHistoruAgentListResult: [],
    deleteApartmentRealestateListResult: [],
    bookingDetails: [],
    bookingDetailsByBookingCode: [],
    allBookingByApartment: [],
    apartmentCustomerInfoBookingDetail: [],
    invoice_booking_payment_detail: [],
    reward_points: [],
    bookingsByApartmentBeforeMoving: [],
    // Documentation
    documents: [],
    documentDetails: {},
    lastThisWEMonthValue: [],
    // Documentation end,
    apartment_leaseback_clients: [],
    detailedReportByEachMonth: [],
    detailedReportAMonth: [],
    // Documentation end,
    bookingPayments: [],
    invoice_general_invoice_list: [],
    invoice_general_invoice_detail: {},
    leaseback_company_list: [],
    groupBookingDetails: [],
    batch_jobs: [],
    statisticsHasBreakFastResidentClients: [],
    period_current: "",
    apartmentrealestate: [],
    apartmentscheduleprogress: [],
    bannerList: [],
    notificationCategory: [],
    templateNotification: [],
    newsResidentsList: [],
    newsList: [],
    newsCategoriesList: [],
    registerExportInvoiceList: [],
    registerExportInvoiceListNoPage: [],
    feedbackList: [],
    feedbackChatList: [],
    feedbackDetailHistory: [],
    departmentList: [],
    departmentListNoPage: [],
    subjectInDepartment: [],
    enableModuleAndExtraInfo: [],
    apartmentTypeList: [],
    apartmentTypeListNoPage: [],
    apartmentGroupList: [],
    apartmentImgList: [],
    apartmentMapImgList: [],
    apartmentContractImgList: [],
    productUnit: [],
    productUnitNoPage: [],
    productGroup: [],
    productGroupNoPage: [],
    productList: [],
    productListNoPage: [],
    serviceList: [],
    serviceHistoryList: [],
    serviceListNoPage: [],
    serviceGroup: [],
    serviceGroupNoPage: [],
    serviceUnit: [],
    serviceUnitNoPage: [],
    serviceAttributeList: [],
    productInApartment: [],
    serviceInApartment: [],
    apartmentInGroup: [],
    apartmentBookingList: [],
    apartmentBookingDetail: [],
    apartmentBookingListForTimeLine: [],
    apartmentTypePriceList: [],
    projectExtraInfo: [],
    apartmentListInBooking: [],
    userListInBooking: [],
    userBookingInApartment: [],
    productInApartmentType: [],
    productInApartmentTypeNoPage: [],
    productAndServiceUsedInApartmentInBooking: [],
    invoiceSearchListStorage: {},
    servicePackageList: [],
    serviceListEnable: [],
    numberServiceOrderList: [],
    servicerOrderList: [],
    servicerOrderDetail: [],
    invoiceRevenueList: [],
    roomRevenueList: [],
    roomPerformanceReportList: [],
    positionList: [],
    userExtraInfo: [],
    eventList: [],
    configEmailGroupList: [],
    configRevenueCodeList: [],
    maintenanceTypeList: [],
    maintenanceFunctionList: [],
    assetV2List: [],
    assetV2ListNoPage: [],
    maintenanceList: [],
    maintenanceDetail: [],
    assetMaintenanceHistoryList: [],
    maintenanceHistoryList: [],
    maintenanceListNoPage: [],
    activityTrackingList: [],
    activityPlanList: [],
    externalLinkList: [],
    frequentlyAskedQuestions: [],
    incidentInFeedbackList: [],
    assetSupplierList: [],
    assetSupplierListNoPage: [],
    approvalApartmentResidentList: [],
    numberApprovalApartmentResident: [],
    isShowWellcomeModal: false,
    invoiceHistoryList: [],
    notificationList: [],
    emailTemplateCategory: [],
    apartmentInGroupWithId: []
  },
  modules: {
    packageModule,
    bookingModule,
    accountingHomeLiabilityModule
  },
  actions,
  mutations,
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js